module.exports = __webpack_public_path__ + "static/media/VideojetConnect SaaS Terms and Conditions 080413.c49cf27a.pdf";